<template>
  <div class="brand">
    <span class="brand__img-wrapper"><img class="brand__img" :src="logo"/></span
    ><span class="brand__text"
      ><span class="brand__text__name">{{ name }}</span
      ><span class="brand__text__desc">{{ desc }}</span></span
    >
  </div>
</template>
<script>
export default {
  props: {
    logo: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    desc:{
      type: String,
      default:""
    }
  }
};
</script>
<style lang="scss" scoped>
.brand {
  width: 912px;
  height: 160px;
  background: rgba(254, 250, 247, 1);
  vertical-align: middle;
  display: inline-block;
  line-height: 160px;
  &__img-wrapper {
    vertical-align: middle;
    text-align: right;
    height: 160px;
    line-height: 160px;
    display: inline-block;
    width: 328px;
    padding-right: 24px;
  }
  &__img {
    vertical-align: middle;
  }
  &__text {
    width: 440px;
    display: inline-block;
    padding-left: 24px;
    padding-right: 95px;
    position: relative;
    line-height:0;
    text-align: left;
    vertical-align: middle;
    &__name {
      display: inline-block;
      vertical-align: middle;
      font-size: 28px;
      font-weight: 300;
      color: rgba(46, 41, 37, 1);
      line-height: 32px;
    }
    &__desc{
      display: inline-block;
      vertical-align: middle;
      line-height: 24px;
      font-size:22px;
      font-weight:300;
      margin-top: 10px;
      color:rgba(125,122,120,1);
    }
  }
}

.brand__text::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #dadada;
  width: 1px;
  height: 90px;
}
</style>